const maskRegExp = /^\d{5}-\d{0,4}?$/;

/**
 * Return a value as masked zip code (#####-####) and calculate its new cursor
 * position.
 */
export function maskZip(
  /** The value that should be masked as ZIP code. */
  value: string | number,
  /** The cursor position before the masking. */
  cursorPosition = 0
): [masked: string, cursorPosition: number] {
  let masked = String(value);
  let newCursorPosition = cursorPosition;

  if (maskRegExp.exec(masked)) {
    // Code is already masked, do nothing
    return [masked, newCursorPosition];
  }

  masked = masked.replace(/\D/g, '');

  if (masked.length > 5) {
    // Mask as #####-#####
    masked = `${masked.substring(0, 5)}-${masked.substring(5, 9)}`;
  }

  if (cursorPosition >= 5 && !String(value).includes('-')) {
    // If the cursor position is after the first 5 digits, move it after the dash
    newCursorPosition = cursorPosition + 1;
  }

  return [masked, newCursorPosition];
}

const cleanRegExp = /-$/;
/** Function to cleanup the zip mask while typing backspace */
export function cleanZipMask(value: string): string {
  let maskedValue = value;
  if (cleanRegExp.exec(value)) {
    maskedValue = value.replace(cleanRegExp, '');
  }
  return maskedValue;
}
